import { UsersServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/users/UsersServiceClientPb';
import {
  GetMailingSettingsRequest,
  GetMailingSettingsResponse,
  UpdateMailingSettingsRequest,
  UpdateMailingSettingsResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/users/users_pb';

export type UsersExportClasses = {
  UsersServiceClient: typeof UsersServiceClient;
  GetMailingSettingsRequest: typeof GetMailingSettingsRequest;
  GetMailingSettingsResponse: typeof GetMailingSettingsResponse;
  UpdateMailingSettingsRequest: typeof UpdateMailingSettingsRequest;
  UpdateMailingSettingsResponse: typeof UpdateMailingSettingsResponse;
  UpdateUserRequest: typeof UpdateUserRequest;
  UpdateUserResponse: typeof UpdateUserResponse;
};

export const users: UsersExportClasses = {
  UsersServiceClient,
  GetMailingSettingsRequest,
  GetMailingSettingsResponse,
  UpdateMailingSettingsRequest,
  UpdateMailingSettingsResponse,
  UpdateUserRequest,
  UpdateUserResponse,
};
